import uiTheme, { fontSizes } from "client/theme/uiTheme";
import { HeadingWrapper } from "client/ui-components/Heading/styles";
import React from "react";
import asurionDevicesImg from "../../../../assets/asurion-home.png";
import { Heading, Text } from "../../../../ui-components";
import { AsurionCTA, ContentSection, ContentWrapper, SectionWrapper } from "./styles";
export default function AsurionHomeSection() {
  return (
    <SectionWrapper>
      <HeadingWrapper>
        <Heading as="h3" variant="h2" className="mb-3" textAlign="center">
          Get protected with Asurion Home+
        </Heading>
        <Text
          fontSize={{ base: fontSizes.base, md: fontSizes.lg }}
          lineHeight={{ base: 1.5 }}
          fontWeight="normal"
          textAlign="center"
        >
          All your devices, one plan, total peace of mind
        </Text>
      </HeadingWrapper>
      <ContentWrapper>
        <img
          src={asurionDevicesImg}
          alt="Asurion devices"
          style={{ maxHeight: 316, maxWidth: "100%" }}
        />
        <ContentSection>
          <Text
            fontSize={{ base: fontSizes.md, md: fontSizes.xl }}
            fontWeight={700}
            heading
            textAlign={{ base: "center", md: "left" }}
          >
            The last protection plan you'll ever need
          </Text>
          <Text
            fontSize={{ base: fontSizes.base, md: fontSizes.lg }}
            lineHeight={{ base: 1.45 }}
            fontWeight="normal"
            textAlign={{ base: "center", md: "left" }}
          >
            It's never fun when the tech you depend on breaks or malfunctions. Home+®, from
            Asurion*, is the one protection plan you need for all your devices. From fast repairs
            and replacements to 24/7 tech support, Home+ takes care of all the tech you care about
            for just $24.99. Say goodbye to multiple protection plans and expiry dates and get
            Home+.
          </Text>

          <AsurionCTA
            aria-label="Sign Up for Home+"
            href="https://www.signup.asurion.com/home-plus/boomerang/steps/personal-info?utm_source=boomerang&utm_medium=homepage&utm_campaign=asurion_homeplus&utm_content=asurion_section_cta"
            target="_blank"
          >
            Sign Up for Home+
          </AsurionCTA>
        </ContentSection>
      </ContentWrapper>
      <Text
        fontSize={{ base: fontSizes.sm }}
        fontWeight="normal"
        color={uiTheme.colors.gray600}
        textAlign="center"
      >
        *Asurion is a service contract provider and is not responsible for or involved in the
        services offered by Boomerang.
      </Text>
    </SectionWrapper>
  );
}
